import { defaultRouteState } from '../../models/redux/DefaultRouteState';
import * as types from './types';

const arrayMove = function (from, to, items) {
  const element = items[from];
  items.splice(from, 1);
  items.splice(to, 0, element);
  return items;
};

const RouteReducer = (state = defaultRouteState, action: any) => {
  switch (action.type) {
    case types.ROUTE_TEMPLATES_GET_REQUEST: {
      state = {
        ...state,
        loadingTemplates: true
      };
      break;
    }
    case types.ROUTE_TEMPLATES_GET_RECEIVED: {
      state = {
        ...state,
        templates: action.payload.filter((template) => template.has_custom_route_order),
        loadingTemplates: false
      };
      break;
    }
    case types.ROUTE_TEMPLATES_GET_ERROR: {
      state = {
        ...state,
        templates: [],
        loadingTemplates: false
      };
      break;
    }
    case types.RECENT_ROUTES_GET_REQUEST: {
      state = {
        ...state,
        loadingRecentRoutes: true
      };
      break;
    }
    case types.RECENT_ROUTES_GET_RECEIVED: {
      state = {
        ...state,
        recentRoutes: action.payload,
        loadingRecentRoutes: false
      };
      break;
    }
    case types.RECENT_ROUTES_GET_ERROR: {
      state = {
        ...state,
        recentRoutes: [],
        loadingRecentRoutes: false
      };
      break;
    }
    case types.ACTUAL_DEPOT_ROUTES_GET_REQUEST:
    case types.ACTUAL_ROUTES_GET_REQUEST: {
      state = {
        ...state,
        loadingActualRoutes: true
      };
      break;
    }
    case types.ACTUAL_DEPOT_ROUTES_GET_RECEIVED:
    case types.ACTUAL_ROUTES_GET_RECEIVED: {
      state = {
        ...state,
        actualRoutes: action.payload,
        loadingActualRoutes: false
      };
      break;
    }
    case types.ACTUAL_DEPOT_ROUTES_ERROR:
    case types.ACTUAL_ROUTES_GET_ERROR: {
      state = {
        ...state,
        actualRoutes: [],
        loadingActualRoutes: false
      };
      break;
    }
    case types.ROUTE_DECLARATION_FORM_INFORMATION_GET_RECEIVED: {
      state = {
        ...state,
        declarationFormInformation: action.payload,
        loadingDeclarationFormInformation: false
      };
      break;
    }
    case types.ROUTE_DECLARATION_FORM_INFORMATION_GET_REQUEST: {
      state = {
        ...state,
        loadingDeclarationFormInformation: true
      };
      break;
    }
    case types.ROUTE_DECLARATION_FORM_INFORMATION_GET_ERROR: {
      state = {
        ...state,
        loadingDeclarationFormInformation: false
      };
      break;
    }

    case types.SWAP_INDEXES: {
      const { a, b, routeIndex } = action.payload;

      const currentTemplates = state.templates;
      const customers = currentTemplates[routeIndex].route_customers;
      const rearranged_customers = arrayMove(a, b, customers);

      currentTemplates[routeIndex].route_customers = rearranged_customers;
      currentTemplates[routeIndex].route_customers.map(
        (customer, index) => (customer.route_order = index)
      );

      state = {
        ...state,
        templates: currentTemplates
      };
      break;
    }
  }

  return state;
};

export { RouteReducer };
